/* eslint-disable import/prefer-default-export */
/* eslint-disable import-helpers/order-imports */

import { useEffect, useState } from 'react';

import useSaflSocket from './useSaflSocket';

const useUsuariosOnline = () => {
  const socket = useSaflSocket();
  const [online, setOnline] = useState(null);

  useEffect(() => {
    if (!socket) {
      return undefined;
    }

    const handleCount = (payload = {}) => {
      const value = Number(payload.online);
      setOnline(Number.isFinite(value) ? value : 0);
    };

    const handleConnect = () => {
      socket.emit('presence:get');
    };

    socket.on('presence:count', handleCount);
    socket.on('connect', handleConnect);

    if (socket.connected) {
      handleConnect();
    }

    return () => {
      socket.off('presence:count', handleCount);
      socket.off('connect', handleConnect);
    };
  }, [socket]);

  return online;
};

export default useUsuariosOnline;
